/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NegotiationDetailsAliases {
  CARD_NEGOTIATION_DETAILS = 'card-negotiation-details',
  CARD_PROPOSALS = 'card-proposals',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_PROPOSALS = 'deck-proposals',
  FETCH_NEGOTIATION = 'fetch-negotiation',
  FETCH_PROPOSALS = 'fetch-proposals',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_CANCEL_REASON = 'field-cancel-reason',
  FIELD_PROPONENT = 'field-proponent',
  FIELD_PROPOSAL = 'field-proposal',
  FIELD_START_DATE = 'field-start-date',
  FIELD_STATUS = 'field-status',
  FIELD_TYPE = 'field-type',
  FORM_NEGOTIATION = 'form-negotiation',
  LAYOUT_NEGOTIATION = 'layout-negotiation',
  PANEL_CARD = 'panel-card',
  PANEL_NEGOTIATION_DETAILS = 'panel-negotiation-details',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_6 = 'text-6',
  TEXT_7 = 'text-7',
  TEXT_8 = 'text-8',
}
export { NegotiationDetailsAliases };
